<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="650"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar color="grey">
            <v-icon>mdi-contactless-payment</v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Pos.SelectOrderPaymentMethodDialog.Toolbar.Title') }}
            </div>
            <div class="text-caption">
              {{ $t('Pos.SelectOrderPaymentMethodDialog.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-0">
          <v-container fluid>
            <v-row dense>
              <template v-for="(paymentMethod, index) in paymentMethods">
                <v-col
                  :key="`payment-method-${paymentMethod.code}-${index}`"
                  cols="12"
                  sm="6"
                >
                  <v-list class="pa-0">
                    <v-list-item
                      :class="[isDarkMode ? 'grey darken-3' : 'grey lighten-3']"
                      class="grey lighten-3 rounded"
                      ripple
                      @click="setPaymentMethod(paymentMethod)"
                    >
                      <v-list-item-avatar
                        :color="paymentMethod.color1"
                        size="46"
                      >
                        <template v-if="paymentMethod.image">
                          <img
                            :src="`${appConfig.LOCATION_DATA.CdnUrl}assets/payments/${paymentMethod.image}`"
                            height="32"
                            width="auto"
                          >
                        </template>

                        <template v-else>
                          <v-icon
                            v-if="paymentMethod.icon"
                            color="white"
                            size="32"
                          >
                            {{ paymentMethod.code === PaymentTypeEnum.CASH ? appCurrency.Icon : paymentMethod.icon }}
                          </v-icon>

                          <v-icon
                            v-if="paymentMethod.icon2"
                            color="white"
                            size="32"
                          >
                            {{ paymentMethod.icon2 }}
                          </v-icon>
                        </template>
                      </v-list-item-avatar>

                      <v-list-item-content :class="isDarkMode ? 'white--text' : 'grey--text text--darken-2'">
                        <v-list-item-title class="text-left">
                          {{ getPaymentMethodName(paymentMethod) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider />
                  </v-list>
                </v-col>
              </template>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            text
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AppData from '@/mixins/appdata.js'
import Auth from '@/mixins/auth.js'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum.js'
import PaymentType from '@/mixins/orders/paymentType.js'

export default {
  name      : 'SelectPaymentMethodDialog',
  components: {},
  mixins    : [AppData, Auth, PaymentType],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },
    paymentMethods: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    PaymentTypeEnum() {
      return PaymentTypeEnum
    },
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    getPaymentMethodName(paymentMethod) {
      const retVal = this.getPaymentTypeLangByCode(paymentMethod?.code)?.Title || paymentMethod?.name || ''

      return retVal.toLocaleUpperCase(this.$i18n.locale)
    },

    setPaymentMethod(paymentMethod) {
      if (!paymentMethod) return

      this.isVisible = false
      this.$emit('select', paymentMethod)
    },

    onCancelButtonClick() {
      this.isVisible = false
    }
  }
}
</script>
